import Vue from 'vue'
import { mapGetters } from 'vuex'
import { maxLength } from 'vuelidate/lib/validators'
import { applyDrag } from '../../views/forms/helpers'

export default {
  mounted () {
    this.updateSavebutton()
  },
  computed: {
    ...mapGetters([ 'idToken', 'userRole', 'userRoleOrder', 'selectedRolesData', 'appMode' ]),
    setFormTypeOptions () {
      let matchOptions = [
        { value: null, text: 'Select File Type' }
      ]
      matchOptions.push(...this.templateOptions)
      return matchOptions
    },
    isSecondEditButtonDisabled () {
      return (key) => {
        return this.selectedTitleDocs !== null && (
          (this.editAttachmentsEnabled !== key && this.editAttachmentsEnabled !== null) || this.isFirstEditButtonClicked
        )
      }
    }
  },
  validations: {
    text: {
      maxLength: maxLength(15),
      valid: function (value) {
        const regexExp = /^[a-zA-Z0-9 _-]*$/.test(value)
        return regexExp
      }
    }
  },
  methods: {
    updateSavebutton () {
      let checkedIdArray = []
      this.$refs.CheckboxClicks.map(element => {
        if (element.checked === true) {
          checkedIdArray.push(element.id)
        }
      })
      if (this.$v.text.$error === true || (checkedIdArray.length === 0)) {
        this.disableSaveButton = true
      } else if (this.isRotatedDoc && (checkedIdArray.length > 0)) {
        this.disableSaveButton = false
      } else {
        this.disableSaveButton = false
      }
    },
    CheckboxClear: function () {
      this.selectAllTemplates = false
      this.selectAllUnmatched = false

      this.$refs.CheckboxClicks.map(element => {
        element.checked = false
      })
      if (!(this.editAttachmentsEnabled || this.editInsCardsEnabled)) {
        this.editedCheckedBoxes = []
      }
      this.text = ''
      this.selectedProduct = []
      this.formType = null
      if (this.isEdited) {
        this.selectedTitleDocs[this.isEditedDocKey]['isEdited'] = false
      }
      this.isSaveButtonClicked = true
      this.isFirstEditButtonClicked = false
      this.isEditedDoc = false
      this.disableSaveButton = true
      this.selectAllThumbnails = false
      this.sortDraggablesForms()
    },
    clearEditedAttachedPages: function () {
      if (this.editAttachmentsEnabled || this.editInsCardsEnabled) {
        this.scene.children.map(column => {
          if (column.type === 'container') {
            column.children.map(element => {
              if (element.data.form && this.selectedTitleDocs[this.editAttachmentsEnabled] && this.selectedTitleDocs[this.editAttachmentsEnabled].attachment_formIds.includes(element.data.form.id)) {
                element.data.form.process = true
                element.data.form.isAttachment = true
                element.data.form.isEdited = false
              }
              if (element.data.form && this.selectedTitleDocs[this.editInsCardsEnabled] && this.selectedTitleDocs[this.editInsCardsEnabled].insurance_ids.includes(element.data.form.id)) {
                element.data.form.process = true
                element.data.form.isInsurance = true
                element.data.form.isEdited = false
              }
            })
          }
        })
        this.editAttachmentsEnabled = null
        this.editInsCardsEnabled = null
      }
    },
    handleTemplateSelect: function () {
      let templateDoc = this.templateOptions.filter(templateDoc => templateDoc.value === this.forced_template_doc_id)
      this.previewImageUrl = this.axios.defaults.baseURL.replace('/api', '') + templateDoc[0].image_url
    },
    rotateSelectedImgs (angle) {
      let checkedIdArray = []
      let checkedFormIds = []
      let origPageNos = []
      this.$refs.CheckboxClicks.map(element => {
        if (element.checked === true) {
          checkedIdArray.push(element.id)
        }
      })
      this.scene.children.map(column => {
        if (column.type === 'container') {
          column.children.map(ele => {
            if (ele.data.form && checkedIdArray.includes(ele.id)) {
              checkedFormIds.push(ele.data.form.id)
              origPageNos.push(ele.data.form.original_page_no)
            }
          })
        }
      })
      if (checkedIdArray.length > 0) {
        this.loading = true
        this.rotateAllAngle = angle
        Vue.axios.post('form_docs/rotate_all_images', { ids: checkedFormIds, rotation_angle: this.rotateAllAngle, original_page_nos: origPageNos, form_doc_id: `${this.$route.params.id}` }, { headers: { Authorization: `Bearer ${this.idToken}` } })
          .then(res => {
            if (res.data.error) {
              Vue.toasted.show(this.$t('FORMS.IMAGE_ROTATE_FAIL'), { icon: 'chain-broken', type: 'error' })
            } else {
              Vue.toasted.show(this.$t('FORMS.IMAGE_ROTATE_SUCCESS'), { type: 'success' })
            }
            let imageData = res.data.image_data
            this.scene.children.map(column => {
              if (column.type === 'container') {
                column.children.map(element => {
                  if (element.data.form) {
                    imageData.map(data => {
                      if (data.form_id === element.data.form.id) {
                        element.data.form.rotation = data.rotation_angle
                        element.data.form.angle = data.rotation_angle
                        element.data.form.rotation_angle = data.rotation_angle
                      }
                    })
                  }
                })
              }
            })
            this.rotateAllAngle = 0
            this.selectAllTemplates = false
            this.selectAllUnmatched = false
            this.CheckboxClear()
          })
          .catch(err => {
            Vue.toasted.show(this.$t('FORMS.IMAGE_ROTATE_FAIL'), { icon: 'chain-broken', type: 'error' })
            console.log(err)
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.$refs.rotatePagesAlert.show()
      }
    },
    imageRotateLeft: function () {
      var img = document.getElementById(this.selectedImage.id)
      this.angle = this.angle - 90
      this.rotationSave = true
      img.style.transform = 'rotate(' + this.angle + 'deg)'
    },
    imageRotateRight: function () {
      var img = document.getElementById(this.selectedImage.id)
      this.angle = this.angle + 90
      this.rotationSave = true
      img.style.transform = 'rotate(' + this.angle + 'deg)'
    },
    closeRotationTemplateImage () {
      this.angle = 0
      this.modelOpen = false
      this.rotationSave = false
      this.$refs['viewFullImage'].hide()
    },
    saveRotationTemplateImage () {
      if (this.rotationSave) {
        let previousAngle = this.angle - this.selectedImage.rotation_angle
        Vue.axios.post('form_docs/rotate_image', { id: this.selectedImage.id, rotation_angle: previousAngle, original_page_no: [this.selectedImage.original_page_no] }, { headers: { Authorization: `Bearer ${this.idToken}` } })
          .then(response => {
            Vue.toasted.show(this.$t('FORMS.IMAGE_ROTATE_SUCCESS'), { type: response.data.error ? 'error' : 'success' })
            this.scene.children.map(column => {
              if (column.type === 'container') {
                column.children.map(element => {
                  if (element.data.form && element.data.form.id === this.selectedImage.id) {
                    console.log('element = ', element, this.selectedImage.id)
                    element.data.form.angle = response.data.rotation_angle
                    element.data.form.rotation = response.data.rotation_angle
                    element.data.form.rotation_angle = response.data.rotation_angle
                  }
                })
              }
            })
            this.angle = 0
            this.modelOpen = false
            this.rotationSave = false
          })
          .catch(err => {
            Vue.toasted.show(this.$t('FORMS.IMAGE_ROTATE_FAIL'), { icon: 'chain-broken', type: 'error' })
            console.log(err)
          })
      }
      this.$refs['viewFullImage'].hide()
    },
    onColumnDrop (dropResult) {
      const scene = Object.assign({}, this.scene)
      scene.children = applyDrag(scene.children, dropResult)
      this.scene = scene
    },
    onCardDrop (columnId, dropResult) {
      if (dropResult.removedIndex !== null || dropResult.addedIndex !== null) {
        const scene = Object.assign({}, this.scene)
        const column = scene.children.filter(p => p.id === columnId)[0]
        const columnIndex = scene.children.indexOf(column)
        const newColumn = Object.assign({}, column)
        newColumn.children = applyDrag(newColumn.children, dropResult)
        scene.children.splice(columnIndex, 1, newColumn)
        this.scene = scene
        this.disableSelectAllOnCardDrop(this.scene)
      }
      if (dropResult.addedIndex !== null && this.isEditedDoc === false) {
        this.sortDraggablesForms()
      }
    },
    getCardPayload (columnId) {
      return index => {
        return this.scene.children.filter(p => p.id === columnId)[0].children[index]
      }
    },
    dragStart () {
    },
    log (...params) {
      console.log(...params)
    },
    viewFullImage (data, column) {
      this.selectedImage = data
      this.selectedColumn = column
      this.forced_template_doc_id = data.template_doc_id
      let templateDoc = this.templateOptions.filter(templateDoc => templateDoc.templates.includes(data.closest_template_id))
      this.previewImageUrl = templateDoc.length > 0 ? this.axios.defaults.baseURL.replace('/api', '') + templateDoc[0].image_url : ''
      data.templateDoc = templateDoc.length > 0 ? templateDoc[0] : {}
      this.modelOpen = true
      this.angle = data.angle
      this.$refs['viewFullImage'].show()
    },
    showModal () {
      this.$refs['viewFullImage'].show()
    },
    hideModal () {
      this.$refs['viewFullImage'].hide()
    },
    extractFormTypeData (column, data) {
      data = data.filter(image => image.data.found && image.data.form && image.data.form.template_doc_id !== 'attachments' && !image.data.coverPage && !image.data.form.isAttachment)
      data = data.map(data => data.data)
      return data
    },
    saveSelectedDocs () {
      // 2 - INPROGRESS, 3 - Partially Completed
      let statusID = null
      if (this.vaildFormsData) {
        statusID = this.traigeStatus['TRIAGED']
      } else if (Object.keys(this.selectedTitleDocs).length > 0) {
        statusID = this.traigeStatus['PARTIALLY_COMPLETED']
      } else {
        statusID = this.traigeStatus['INPROGRESS']
      }
      Vue.axios.post('form_docs/save_triage_docs', {selected_docs: this.selectedTitleDocs, triage_doc_id: this.$route.params.id, status_id: statusID}, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          this.validAllForms()
        })
        .catch(err => {
          console.log(err)
        })
    },
    rejectForm () {
      let res = {
        formDocId: `${this.$route.params.id}`
      }
      Vue.axios.post('form_docs/reject_form_docs', res, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          this.hideRejectFormDocModal()
          this.$router.push('/process/processed')
          Vue.toasted.show(`Form will remain in the system for ${res.data.retention_time} hours`, { icon: 'chain-broken', type: 'success' })
        })
        .catch(err => {
          console.log(err)
          Vue.toasted.show(res.data.message, { type: res.data.error ? 'error' : 'success' })
        })
    },
    setDocumentStatus (status) {
      Vue.axios.post('form_docs/set_traige_document_status', {triage_doc_id: this.$route.params.id, status}, { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
        })
        .catch(err => {
          console.log(err)
        })
    },
    showRejectFormModal () {
      this.$refs.rejectFormDoc.show()
    },
    hideRejectFormDocModal () {
      this.$refs.rejectFormDoc.hide()
    },
    disableCheckboxOnEditedDoc () {
      this.isEditedDoc && this.updateDisableCheckBox()
    },
    removePages (patientDetails, key) {
      this.scene.children.map(column => {
        if (column.type === 'container') {
          column.children.map(element => {
            if (element.data.form && patientDetails.formIDs.includes(element.data.form.id)) {
              element.data.form.process = false
              element.data.form.isEdited = false
            }
          })
        }
      })
      this.$delete(this.selectedTitleDocs, key)
      if (this.editAttachmentsEnabled === key) {
        this.editAttachmentsEnabled = null
      }
      this.validAllForms()
      this.CheckboxClear()
      this.saveSelectedDocs()
    },
    editPages (patientDetails, key) {
      this.editedCheckedBoxes = []
      this.isFirstEditButtonClicked = true
      this.scene.children.map(column => {
        if (column.type === 'container') {
          this.extractFormTypeData(column.name, column.children)
          column.children.map(element => {
            if (element.data.form && patientDetails.formIDs.includes(element.data.form.id) && !(patientDetails.attachment_formIds.includes(element.data.form.id)) && !(patientDetails.insurance_ids.includes(element.data.form.id))) {
              element.data.form.isEdited = true
              // TODO: PDX-285
              this.editedCheckedBoxes.push(element.data.form.id)
            } else if (element.data.form) {
              element.data.form.isEdited = false
            }
          })
        }
      })
      Object.keys(this.selectedTitleDocs).map(docTitle => {
        this.selectedTitleDocs[docTitle]['isEdited'] = false
      })
      this.selectedTitleDocs[key]['isEdited'] = true
      this.text = patientDetails['title']
      this.isEditedDoc = true
      this.disableSaveButton = false
      this.isEditedDocKey = key
      // this.selectedEditTitle = key
      this.formType = patientDetails['formType']
      this.isPatientIdSelected = Boolean(patientDetails['patient_id'])
      this.selectedForceTemplate = patientDetails['force_template_id']
      this.sortEditedForms()
    },
    sortEditedForms () {
      this.scene.children.map(column => {
        if (column.type === 'container' && this.isEditedDoc) {
          column.children.sort((a, b) => {
            if (a.data.form && b.data.form) {
              if (a.data.form.isEdited === true && b.data.form.isEdited === true) {
                return column.children.indexOf(a) - column.children.indexOf(b)
              }
              if (a.data.form.isEdited === false) return 1
              if (a.data.form.isEdited === true) return -1
              return column.children.indexOf(a) - column.children.indexOf(b)
            } else {
              return 0
            }
          })
        }
      })
    },
    validAllForms: function () {
      // validate the all forms in templates,IC and DL
      let validAllForms = true
      this.scene.children.map(column => {
        if (column.type === 'container' && ['Templates', 'Insurance cards', 'Drivers License', 'Unmatched Pages'].includes(column.name)) {
          column.children.map(element => {
            if (element.data.form) {
              if (element.data.form.process === false) {
                validAllForms = false
              }
            }
          })
        }
      })
      this.vaildFormsData = validAllForms
    },
    getResultCss: function (value) {
      return value['isEdited'] && this.isEditedDoc ? 'edit-result' : 'result'
    },
    loadingImage (e, data) {
      // this.angle = data.angle
      // var img = e.target
      // img.style.transform = 'rotate(' + this.angle + 'deg)'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/Triaging.js